import dayjs from 'dayjs';

const dateParser = (date) => {
  if (date) {
    return dayjs(date).tz('Asia/Jakarta').format();
  }
  return null;
};

export default dateParser;
